import { useMenu } from '@if/mui'
import BuildIcon from '@mui/icons-material/Build'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import { Button, Collapse, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material'
import { useUser } from '@src/providers/UserProvider'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

const AdminMenu = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const user = useUser()
  const [buttonProps, menuProps] = useMenu()
  const [openSubMenu, setOpenSubMenu] = useState(false)

  const canExecuteDevTools = user?.rights.canExecuteDevTools ?? false

  const handleTransactionRetryClick = () => {
    navigate('/admin/transaction-retry')
  }

  return (
    <>
      <Button {...buttonProps}>{t('menus.admin.admin')}</Button>
      <Menu {...menuProps}>
        <MenuItem>{t('menus.admin.rapport')}</MenuItem>
        {canExecuteDevTools && (
          <MenuItem onClick={() => navigate('/admin/dev-tools')}>
            <ListItemIcon>
              <BuildIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t('menus.admin.devTools')} />
          </MenuItem>
        )}
        <MenuItem onClick={() => setOpenSubMenu(!openSubMenu)}>
          <ListItemText primary={t('menus.admin.comptability')} />
          {openSubMenu ? <ExpandLess /> : <ExpandMore />}
        </MenuItem>
        <Collapse in={openSubMenu} timeout="auto" unmountOnExit>
          {/* Submenu items go here */}
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.exportLoan')}</MenuItem>
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.exportIfSales')}</MenuItem>
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.exportWithProducts')}</MenuItem>
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.eligibleCreance')}</MenuItem>
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.plannedPPA')}</MenuItem>
          <MenuItem sx={{ pl: 4 }}>{t('menus.admin.extractionDealerTrackRebate')}</MenuItem>
          <MenuItem sx={{ pl: 4 }} onClick={handleTransactionRetryClick}>
            {t('menus.admin.transactionRetry')}
          </MenuItem>
        </Collapse>
      </Menu>
    </>
  )
}

export default AdminMenu
